import { FileType, getFileTypeConfiguration } from "config/FileTypeConfiguration";
import { httpService } from "service/http.service";
import { AxiosError } from "axios";
import { ErrorResponse } from "service/ErrorResponse";

export interface UploaderErrorResponse {
  statusCode?: string;
  errorCode?: string;
  message?: string;
}

enum UploadFileResponseStatus {
  SUCCESSFUL = "SUCCESSFUL",
  ERROR = "ERROR",
}

enum ValidationProfile {
  FULL = "FULL",
  REDUCED = "REDUCED",
}

export interface UploadFileResponse {
  status: UploadFileResponseStatus;
  error?: UploaderErrorResponse;
}

export const uploadFile = (
  formData: FormData,
  configurationId: string,
  jwtAuthorization: string,
  fileType: FileType,
  withLoosenedValidation?: boolean
): Promise<UploadFileResponse> => {
  const endpointUrl = getFileTypeConfiguration(fileType)?.endpointUrl;

  if (endpointUrl) {
    return new Promise((resolve, reject) => {
      httpService
        .post<FormData, UploadFileResponse>(endpointUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Configuration-Id": configurationId,
            jwtAuthorization: jwtAuthorization,
            "X-Validation-Profile": withLoosenedValidation ? ValidationProfile.REDUCED : ValidationProfile.FULL,
          },
        })
        .then(() => {
          resolve({
            status: UploadFileResponseStatus.SUCCESSFUL,
          });
        })
        .catch((response: AxiosError<ErrorResponse>) => {
          reject({
            status: UploadFileResponseStatus.ERROR,
            error: {
              ...response.response?.data,
              statusCode: response.response?.status,
              requestId: response.request.requestId,
            },
          });
        });
    });
  } else {
    return Promise.reject();
  }
};
